import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-title">&copy; Caliber Group Ltd 2024</p>
    </footer>
  );
};

export default Footer;
